// @flow
import {
  getBICData,
  setIcUserCookie,
} from '../../api/controllers/buyWithInstacredController';
import { bicActionType } from '../../actionTypes';
import { tracker } from '../../tracking';
import { setLocalStorage } from '../../utils';
import { USER_UUID_COOKIE_KEY } from '../../tracking/helper';
import {
  bigCOfferLenders,
  lotMobilesOfferLenders,
  sangeethaOfferLenders,
} from '../../constants/offerSupportLenders';
export default (payload: Object) => (dispatch: Function) => {
  dispatch({ type: bicActionType.GET_BIC_API_INITIATED, payload });
  const { queryParamUserUuid, ...others } = payload || {};
  getBICData(others)
    .then(({ data: respData }) => {
      if (queryParamUserUuid) {
        setIcUserCookie({ uuid: queryParamUserUuid }).then(
          ({ data: respData }) => {
            if (respData && respData.identified) {
              setLocalStorage(USER_UUID_COOKIE_KEY, queryParamUserUuid);
              tracker.pushUserProfile();
            }
          },
        );
      }

      //This is done for making offers contextual, need to remove when we bring the data from database.
      respData &&
        respData.offers &&
        respData.offers.forEach((offer, i) => {
          if (offer.handle === 'bigc') {
            offer.supportedLenders = { ...bigCOfferLenders };
          } else if (offer.handle === 'lotmobiles') {
            offer.supportedLenders = { ...lotMobilesOfferLenders };
          } else {
            offer.supportedLenders = {};
          }
        });
      return dispatch({
        type: bicActionType.GET_BIC_API_SUCCESS,
        payload: respData,
      });
    })
    .catch((error) => {
      return dispatch({ type: bicActionType.GET_BIC_API_ERROR, payload: {} });
    });
};



// WEBPACK FOOTER //
// ./actions/bicAction/getBIC.js